
bq.accountingManagement = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.dataContainer = false;
  this.form = false;
  this.formElements = false;
  this.isInValid = false;
  this.accounts = 0;
  this.eventNames = {
    change: 'bq.accounting.changed',
    update: 'bq.accounting.update',
    refresh: 'bq.accounting.refresh',
    load: 'bq.accounting.load',
    clear: 'bq.accounting.clear'
  };
};

bq.accountingManagement.DEFAULTS = {
    edit: true,
    split: true,
    maxSplit: 1,
    entityContainerClass: 'accounting-container',
    entityContainerSelector: '.accounting-container:visible',
    dataContainer: '.accounting-data',
    formElementsContainer: '.accounting-form-elements',
    formContainer: '.accounting-form',
    favFormContainer: '.accounting-save-favorite',
    favFormButtons: '.accounting-save-favorite a[data-bq="collapse"]',
    tabAccounting: '.tab-accounting-container',
    broadcastChanges: false,
    ajaxSingleUrl: false,
    loadAjax: false,
    hideOnEdit: false,
    accountingKeys: {},
    inputPrefix: 'accounting',
    parentClear: '.form-accounting-clear',
    errorMessageContainer: '.invalid-message',
    loadingHtml: '<div class="loading-block-inline loading-block-inline-small active"><span>'+bq.messages.global.loading+'</span></div>'
};

bq.accountingManagement.prototype = {
  init: function() {
    bq.debug.log("Accounting : init()", this.$element);

    this.dataContainer = $(this.options.dataContainer, this.$element);
    this.form = $(this.options.formContainer, this.$element);
    this.formElements = $(this.options.formElementsContainer, this.$element);

    if(!this.dataContainer || !this.formElements) {
        bq.debug.error("Accounting : Unable to locate required dom elements", this);
        return;
    }

    this._processDataContainer();
    this._setMode('view');

    if(this.options.edit) {

        //lets set events for the datacontainer actions
        this.$element.on('click', '[data-action-edit], [data-action-remove], [data-action-split]', {context:this}, this._catchDataActionEvent);

        //events for form
        this.$element.on('click', '[data-form-cancel], [data-form-save], [data-form-save-split]', {context:this}, this._catchFormActionEvent);

        //change event on allocation
        this.$element.on('change', '[data-form-allocation]', {context:this}, this._catchDataChangeEvent);

        this.$element.on('change', '[data-form-make-default]', {context:this}, this._catchCheckboxUpdate);

        //catch refresh action
        this.$element.on(this.eventNames.refresh, {context:this}, this._catchRefreshEvent);

        //events for favorite accounting buttons open/close click
        this.$element.on('click', this.favFormButtons, {context:this}, this._catchFormFavoriteEvent);

        this._prepareSplitButton(this.$element);

        // catch process accounting split button
        this.form.on('change', 'input.selectbox-data', {context:this}, function(e) {
            var thiz = e.data.context;
            var element = $(e.currentTarget);
            thiz._processSplitButton(element);
        });
    }

    if(this.options.loadAjax) {
        this.$element.on(this.eventNames.load, {context:this}, this._catchLoadEvent);
    }

    var parentForm = this.$element.closest('form');

    if(!parentForm) { parentForm = this.$element; }

    parentForm.on(this.eventNames.update, {context:this}, this._catchUpdateEvent);

    if(this.options.parentClear) {
        parentForm.on('click', this.options.parentClear, {context:this}, this._catchClearEvent);
    }

    $('.account-form-element', this.$element).on("accounting-select-change", {context:this}, this._catchAccountingSelectUpdate);
    $('.account-form-element', this.$element).on("select2-clearing", {context:this}, this._catchAccountingSelectUpdate);

    this._updateFormElements(true);

    if(this.accounts === 0) {
        this._clearAllData();
        $('[data-form-cancel]').hide();
    }

    this._initConditionalGroupValidations();
  },

  _initConditionalGroupValidations: function () {
      var self = this;
      var parentGroupIds = this.form.find('[data-required-on]').map(function() {
          return $(this).data('required-on');
      }).get();

      var uniqueParentGroupIds = [...new Set(parentGroupIds)]
      uniqueParentGroupIds.forEach(function (id) {
          $.each(self.form.find('[data-accounting-input="'+id+'"]'), function(index, element) {
              if (!$(element).val()) {
                  $(element).closest('.account-form-element').trigger('select2-clearing');
              }
          });
      })
  },

  getAccounting: function(mapNames = false) {
    var result = [], self = this;
    $('[data-key]', self.dataContainer).each(function () {
        var el = $(this),
            values = $('[data-values]', el).data('values'),
            mapped = Object.assign({}, values);
        if (mapNames) {
            for (var index in mapped) {
                if (self.options.accountingKeys[index] !== undefined
                    && self.options.accountingKeys[index] !== mapped[index]
                ) {
                    mapped[self.options.accountingKeys[index]] = mapped[index];
                    delete mapped[index];
                }
            }
        }
        result[el.data('key')] = mapped;
    });
    return result;
  },

  setAccounting: function(accounting) {
    var $this = this;
    $('[data-key]', this.dataContainer).remove();
    $.each(accounting, function(index, account){
        var key = $this._createNewDataContainerBlock();
        $this._updateDataContainerSingle(account, key);
    });
    return this;
  },

  _prepareSplitButton: function(form) {
    $('.accounting-form input[name^=accounting_form]:hidden:first-child', form).each($.proxy(function(idx, value){
      this._processSplitButton(value);
    }, this));
  },

  _processSplitButton: function(input) {
    if (!$(input).is('input')) return;

    var inputName=$(input).prop('name');
    if (!inputName.match(/^accounting_form.*/)) return;

    var accountingForm=$(input).closest('div.accounting-form');
    var splitButton=$('[data-form-save-split]', accountingForm);
    if (splitButton) {
      var emptyInputs=[];
      $('input[name^=accounting_form]:hidden', accountingForm).map(function(idx, val){
        var inp=$(val);
        var placeholder=inp.attr('placeholder');

        if (!inp.attr('required')){
          return;
        }

        if (inp.val() == ''){
          emptyInputs.push(val);
          return;
        }

        if (placeholder && inp.val() == placeholder){
          emptyInputs.push(val);
        }
      });

      if (emptyInputs.length){
        splitButton.attr('disabled', true);
      } else {
        splitButton.attr('disabled', false);
      }
    }
  },

  _processDataContainer: function() {
    var $this = this,
        count = 0,
        $accounts = $('[data-key]', this.dataContainer),
        split = $accounts.length,
        invalid = false;


    $accounts.each(function() {
        var $el = $(this);
        if($el.html() !== '') {

            if(count === 0 || !$this.options.edit || !$this.options.split) {
                // if its the first one, lets remove the remove button
                $('[data-action-remove]', $el).parent().addClass('hide');
            } else {
                $('[data-action-remove]', $el).parent().removeClass('hide');
            }

            if(!$this.options.split || count !== 0 || split >= $this.options.maxSplit) {
                //either they cant split or have exceeded the amount of split buttons
                $('[data-action-split]', $el).parent().addClass('hide');
            } else {
                $('[data-action-split]', $el).parent().removeClass('hide');
            }

            if(!$this.options.edit) {
                $('[data-action-edit]', $el).parent().addClass('hide');
            } else {
                $('[data-action-edit]', $el).parent().removeClass('hide');
            }

            if($el.find('[data-invalid]').length >= 1) {
                invalid = true;
            }
            count++;
        }
    });

    this._setInvalidMessage(invalid);

    this.accounts = count;

  },

  _updateForm: function(values) {
    var $this = this,
        inputMax = false;

    /* Make sure children get values after their parents */
    var inputs = this.form.find('[data-accounting-label]').sort(function (i1, i2) {
        var sb1 = $(i1).parent('[data-bq=selectbox-data]');
        var sb2 = $(i2).parent('[data-bq=selectbox-data]');
        var sId1 = sb1.data('select-id');
        var sId2 = sb2.data('select-id');
        var pId1 = sb1.data('parent-filter');
        var pId2 = sb2.data('parent-filter');
        if (!pId1 || sId1 == pId2) {
            return -1;
        } else if (!pId2 || sId2 == pId1) {
            return 1;
        } else {
            return $(i1).data('accounting-input') < $(i2).data('accounting-input') ? -1 : 1;
        }
    });
    if(!values) {
        //reset the form
        inputs.each(function(){
            var input = $(this);
            if(input.data('select2')) {
                var select = input.closest('[data-bq="selectbox-data"]');
                if (input.val() && !select.data('init-data')) {
                    bq.helper.throwEvent('bq.selectboxdata.resetInit', select);
                }

                input.data('default-value', '');
                input.select2('val', '', true);
            } else {
                input.val('100');
            }


        });
    } else {
        if(this.form.data('mode') === 'split') {
            inputMax = Math.round(values.Allocation / 2);
        }
    }

    inputs.each(function () {
        var input = $(this);
        var k = input.data('accounting-label');
        var v = values[k] || '';
        //var select = input.closest('[data-bq="selectbox-data"]');
        if(input.data('select2')) {
            input.data('default-value', v);
            input.select2('val', v, true);
        } else {
            if(k === 'Allocation' && inputMax) {
                v = inputMax;
            }
            input.val(v);
        }
    });

    //Split button state depends on new form values
    this._prepareSplitButton(this.$element);
  },

  _updateFormElements: function(ignore) {
    var $this = this,
        eventData = [],
        count = $('[data-key]', this.dataContainer).length,
        amount = 0;

    $this.formElements.html('');

    var accounting = this.getAccounting();
    $('[data-key]', this.dataContainer).each(function(index){
        var el = $(this),
            key = el.data('key'),
            data = accounting[key];
            $this._createFormElementGroup(key, data);
            amount = $this._updateIndividualSplitAmount(el, amount, index == (count - 1));
            eventData.push({key: key, data: data});
    });

    if(!ignore) {
        bq.helper.throwEvent(this.eventNames.change, this.$element, eventData);
        this._broadcast();

	    if (this.dataContainer.closest(this.options.tabAccounting)) {
	      $this._throwEventUpdateTab();
		    $this._updateSlideHeight(this.dataContainer);
	    }
    }

    setTimeout(function() {
      bq.preValidationInit();
    }, 0);
  },

  _createFormElementGroup: function(key, data) {
    var prefix = this.options.inputPrefix+'['+key+']',
        $this = this;

    if(!data) { return; }

    if(data.is_default === "true"){
      $('[name="accounting_form[is_default]"]').prop('checked', true);
    }

    $.each(data, function(k,v){
        var label = k;
        if($this.options.accountingKeys[k]) {
            label = $this.options.accountingKeys[k];
        }

        var name = prefix + '['+label+']';

        var input = $('<input />', {
            name: name,
            value: v,
            type: "hidden"
        });
        $this.formElements.append(input);
    });
  },

  _setInvalidMessage: function(invalid) {
    this.isInValid = invalid;

    var messageContainer = this.$element.find(this.options.errorMessageContainer);
    var messageClass = this.$element.find('[combination-item]') ? '.combination' : '.no-combination';

    $(messageClass, messageContainer).show();

    if(invalid) {
      this._hideOnEdit(false);
      messageContainer.show();
    } else {
      this._hideOnEdit(true);
      messageContainer.hide();
    }
  },

  _hideErrorMessages:function() {
    var messageContainer = this.$element.find(this.options.errorMessageContainer);

    messageContainer.hide();
  },

  _recalculateKeys: function() {
    var count = 0;

    $('[data-key]', this.dataContainer).each(function(){
        var el = $(this);
        el.data('key', count);
        count++;
    });
  },

  _processRemove: function(el) {
    var removeVal = el.closest('[data-key]').find('[data-form-allocation]').val();
    var main = $('[data-key="0"]', this.dataContainer).find('[data-form-allocation]').val();

    var newAllocation = +(parseFloat(removeVal) + parseFloat(main)).toFixed(12);

    el.closest('[data-key]').remove();
    this._updateAllocation(newAllocation, '0');
    this._recalculateKeys();
    this._processCancel($(el));
    this._processDataContainer();
    this._updateFormElements();
    this._hideOnEdit(true);


  },

  _processEdit: function(el, mode) {
    var values = this._getDataFromContainer(el);
    var key = this._getKeyFromContainer(el);

    this.form.data('mode', mode);
    this.form.data('edit', key);
    this.form.data('split', key);
    $('[data-form-cancel]').show();

    el.closest('[data-bulk-container]')
        .find('.onepage-apply-wrap')
        .hide();

    this._updateForm(values);
    this._setMode('edit');

    this._destroySetupValidation(this.form);

    bq.helper.smoothScroll(this.form);
  },

  _processCancel: function(el) {

    if(this.accounts === 0) {
        this._updateForm(false);

        //if page contains #addaccounting form, on cancel go back
        if($('form#addaccounting')) {
            window.history.go(-1);
        }
        return;
    }

    this.form.data('mode', false);
    this.form.data('edit', false);
    this.form.data('split', false);

    $(el).closest('[data-bulk-container]')
        .find('.onepage-apply-wrap')
        .show();

    this._updateForm(false);
    this._setMode('view');
  },

  _processSave: function(el, shouldSplit) {

    var $data = this._generateAccountJson(),
        invalids  = 0;

    el.parents('.accounting-form').find('[data-parsley-required]').each(function(){
      $(this).parsley().validate();
      if(!$(this).parsley().isValid()) {
        invalids++;
      }
    });

    if(invalids > 0) {
      return false;
    }

    if(this.form.data('mode') === 'edit') {

        this._updateDataContainerSingle($data, this.form.data('edit'), shouldSplit);
    } else {
        var newAllocation = $data.Allocation;
        var input = $('[data-key="'+this.form.data('split')+'"]', this.dataContainer).find('[data-form-allocation]');
        var tmpVal =  +(parseFloat(input.val()) - parseFloat(newAllocation)).toFixed(12);

        this._updateAllocation(tmpVal, this.form.data('split'));
        var key = this._createNewDataContainerBlock();
        this._updateDataContainerSingle($data, key, shouldSplit);
    }
  },

  _updateIndividualSplitAmount: function($el, $amount, isLast){
      var splitPercentage = $el.find('[data-form-allocation]').value,
          $parentContainer = $($el.parents('.accounting-container')[0]),
          $parentSplitTotal = parseFloat($parentContainer.data('split-group-total')),
          items = $parentContainer.data('split-prepare-items'),
          $parent = $parentContainer.closest('.item-list'),
          splitAmount = $parentSplitTotal * (parseFloat(splitPercentage) / 100);

      if(isNaN($parentSplitTotal)) { return; }

      var $item = 0;
      if ($parent.length == 0 && items[0]) {//header level
          $item = items[0];
      } else if ($parent.data('item-id') && items[$parent.data('item-id')]) {// line level
          $item = items[$parent.data('item-id')];
      } else if ($parentContainer.data('item-id') && items[$parentContainer.data('item-id')]) {
          $item = items[$parentContainer.data('item-id')];
      }

      var qty = $parent.closest('.ss-line-item').find('.split_shipping_qty').val();
      if (!qty) {
          qty = 1;
      }

      if ($item) {
          $parentSplitTotal = parseFloat(qty * $item['amount']);
          splitAmount = Math.round(100 * $parentSplitTotal * (parseFloat(splitPercentage) / 100)) / 100;
          if ($amount == 0) {
              $amount = $parentSplitTotal - splitAmount;
          } else if (!isLast) {
              $amount = $amount - splitAmount;
          } else {
              splitAmount = $amount;
          }
      }

      $parentContainer.data('split-group-total', splitAmount);

      $el.find('[data-split-level-subtotal]').text(accounting.formatMoney(splitAmount));
      return $amount;
  },

  _updateAllocation: function(newAllocation, key) {

    var input = $('[data-key="'+key+'"]', this.dataContainer).find('[data-form-allocation]');

    if(newAllocation < 1) {
        newAllocation = 1;
    } else if(newAllocation > 100) {
        newAllocation = 100;
    }

    if(input) {
        input.val(newAllocation).change();
    }
  },

  _createNewDataContainerBlock: function() {
    var lastKey = $('[data-key]', this.dataContainer).length;

    var newEl = $('<div class="account-data" data-key="'+lastKey+'"></div>');

    this.dataContainer.append(newEl);

    return lastKey;
  },

  _updateDataContainerSingle: function(account, key, shouldSplit) {
    var data = $.extend({}, this.options.ajaxSingleData, {mode: 'edit', account: account}),
        e = $('[data-key="'+key+'"]', this.dataContainer),
        fallback = e.html(),
        $this = this;

        this._setContainerAccountLoading(e);
        this._hideErrorMessages();
        if(shouldSplit) {
            this.form.data('mode', 'split');
            this.form.data('edit', key);
            this.form.data('split', key);
            var allocationInput = this.form.find('[data-accounting-input="Allocation"]');
            allocationInput.val(Math.round(allocationInput.val() / 2));
            this._setMode('edit');

        } else {
            this._setMode('view');
            bq.helper.smoothScroll(e);
            this._hideOnEdit(false);
        }

    e.loadSingle(this.options.ajaxSingleUrl, data, function(responseText, textStatus, jqXHR) {
      var error = false;
      var tmpEl = '';

      if(!shouldSplit) {
          $this._hideOnEdit(true);
      }

      if(textStatus == 'Success') {
        tmpEl = $(responseText);

        if(!tmpEl.find('[data-error]')) {
            error = false;
        }
      }

      if(error) {
        e.html(fallback).append(tmpEl);
        $this._setMode('edit');
      } else {

        if(!shouldSplit) {
            $this._updateForm(false);
            $($this.options.hideOnEdit).show();
        }

        $this._processDataContainer();

        if(shouldSplit) {
            $this._hideOnEdit(false);
            $($this.options.hideOnEdit).hide();
        }
      }

      $this._updateFormElements();
    });

  },

  _broadcast: function() {
    if(this.options.broadcastChanges) {
        var $this = this;
        var accounting = $this.getAccounting(true);
        $('[data-bq="accounting"]').not("#"+$this.$element.attr('id')).each(function(){
            var el = $(this);
            el.data('bq.accountingManagement').setAccounting(accounting);
        });
    }
  },

  _generateAccountJson: function() {
    var data = {};
    this.form.find('[data-accounting-input]').each(function(){
        var el = $(this);
        var key = el.data('accountingInput');
        data[key] = key == 'is_default' ? el.is(':checked') : el.val();
    });

    return data;
  },

  _updateDataAllocationJson: function (el) {
      var newValue = el.val(),
          container = el.closest('[data-values]'),
          data = container.data('values');

      el.attr('value', el.val());
      if ($(el).attr('name') == 'accounting_allocation_input[]') {
          data.Allocation = newValue;
      }

      container.attr('data-values', JSON.stringify(data));
      container.data('values', data);
  },

  _setContainerAccountLoading: function(el) {
    if(el) {
        el.html(this.options.loadingHtml);
    }
  },

  _getDataFromContainer: function(el) {
    return el.closest('[data-values]').data('values');
  },

  _getKeyFromContainer: function(el) {
    return el.closest('[data-key]').data('key');
  },

  _setMode: function($mode) {
    switch($mode) {
        case 'view':
            this.form.addClass('hide');
            this._hideOnEdit(true);
            if (!this.isInValid) {
                $(this.options.hideOnEdit).show();
            }
            break;
        case 'edit':
            this.form.removeClass('hide');
            this._hideOnEdit(false);
            $(this.options.hideOnEdit).hide();
            $('.form-element-split .is-default-accounting').show();
            break;
    }
  },

  _hideOnEdit: function(show) {
    if(!this.options.hideOnEdit) { return; }

    if(show && !this.isInValid) {
        $(this.options.favFormContainer, this.$element).show();
        $(this.options.hideOnEdit).show();
    } else {
        $(this.options.hideOnEdit).hide();
        $(this.options.favFormContainer, this.$element).hide();
    }
  },

  _updateFull: function(html) {
    this.dataContainer.html(html);
    this._processDataContainer();
    this._updateFormElements(true);

  },

  _clearAllData: function() {
    this._updateFull('');
    this._processDataContainer();
    this._createNewDataContainerBlock();
    this.form.data('mode', 'edit');
    this.form.data('edit', 0);
    this.form.data('split', 0);
    this._setMode('edit');

  },

  _loadData: function(id) {
    var e = $('[data-key="0"]', this.dataContainer),
        $this = this;
    this._setContainerAccountLoading(e);
    this._setMode('view');
    bq.helper.smoothScroll(e);

    $('#shipping-buttons-container button').prop('disabled', true);

    this.dataContainer.load(this.options.loadAjax, {id: id}, function(responseText, textStatus, jqXHR){
        var error = false;
        var tmpEl = '';

        if(textStatus == 'Success') {
          tmpEl = $(responseText);

          if(!tmpEl.find('[data-error]')) {
              error = false;
          }
        }

        if(error) {
          $this._clearAllData();
        } else {
          $this._updateForm(false);
          $this._processDataContainer();
          $('#shipping-buttons-container button').prop('disabled', false);
        }

        $this._updateFormElements();
    });
  },

  _destroySetupValidation: function(el) {
    el.removeClass('has-error has-feedback has-success');
    $('.form-control-feedback', el).tooltip('destroy').remove();

    if (bq.global.parsley.validationEnabledForElement(el) || el.closest('[data-bq="validate-form"].bq-form').length <= 0) {
      bq.global.parsley.destroyElement(el);
      bq.global.parsley.setupElement(el);
    } else {
      bq.global.parsley.destroySingle(el);
      bq.global.parsley.setupSingle(el);
    }
  },

  _validateAllocation: function(parent) {
    var valid = true;

    parent.find('input[type="text"][data-form-allocation]').each(function(){
      if (!bq.global.parsley.validationEnabled($(this))) {
        bq.global.parsley.setupSingle($(this));
      }

      if (bq.global.parsley.validate($(this)).length) {
        valid = false;
      }
    });

    return valid;
  },

  _catchDataActionEvent: function(e) {
    var $this = e.data.context,
        $el = $(e.currentTarget);

    if ($el.data('actionRemove') === '') {
        $this._processRemove($el);
    } else if($el.data('actionEdit') === '') {
        $this._processEdit($el, 'edit');
        bq.helper.throwEvent('bq.accounting.editing', $this.$element);
    } else if($el.data('actionSplit') === '') {
        $this._processEdit($el, 'split');
        bq.helper.throwEvent('bq.accounting.editing', $this.$element);
        $('[data-form-allocation-edit-mode]').change();
    }

	if ($this.dataContainer.closest($this.options.tabAccounting)) {
	    $this._updateSlideHeight(e.target);
	}
  },

  _catchFormActionEvent: function(e) {
    var $this = e.data.context,
        $el = $(e.currentTarget),
        $accountingContainer = $($el).closest('div.accounting-container'),
        $accountingForm = $($el).closest('div.accounting-form'),
        hasErrors = false;

    if($el.data('formCancel') === '') {
        bq.helper.throwEvent('bq.accounting.canceledit', $this.$element);
        $this._processCancel($el);
    } else if($el.data('formSave') === '') {
        $el.closest('[data-bulk-container]')
            .find('.onepage-apply-wrap')
            .show();
        var $validateItems = $($accountingContainer).find('input[type="text"].ignore-exclude[data-parsley-required]').not('.deactivate-validation');
        $validateItems.each(function(i, el){
          $(el).removeClass('ignore-exclude');
        });

        if($accountingContainer.parent().find('#fav_name').length) {
          $validateItems.push($accountingContainer.parent().find('#fav_name'));
        }

        var accountingForm = $($accountingContainer).find('.accounting-form');

        $this._destroySetupValidation(accountingForm);

        $validateItems.each(function(i, el){
          if($(el).parsley().validate().length) {
            hasErrors = true;
          }
          $(el).addClass('ignore-exclude');
        });

        if (bq.global.parsley.validationEnabledForElement(accountingForm) || accountingForm.closest('[data-bq="validate-form"].bq-form').length <= 0) {
          bq.global.parsley.setupElement(accountingForm);
        } else {
          bq.global.parsley.setupSingle(accountingForm);
        }

        if (!$this._validateAllocation($($accountingForm))) {
          hasErrors = true;
        }

        if(hasErrors){
          return false;
        } else {
          $this._processSave($el);
        }
    } else if($el.data('formSaveSplit') === '') {
      if (!$this._validateAllocation($($accountingForm))) {
        hasErrors = true;
      }

      if(hasErrors){
        return false;
      } else {
        $this._processSave($el, true);
        $('[data-form-allocation-edit-mode]').change();
      }
    }

	  if ($this.dataContainer.closest($this.options.tabAccounting)) {
		  $this._updateSlideHeight(e.target);
	  }
  },

  _catchDataChangeEvent: function(e) {
    var $this = e.data.context,
        $el = $(e.currentTarget);
        if($el.attr('value') === $el.val() && !$el.data('need-update')) { return; }
        $el.data('need-update', false);

        if($el.is('[data-form-allocation-edit-mode]')){
            $this._updateIndividualSplitAmount($el.parent().parent(), 0, false);
            return;
        }
        $this._updateDataAllocationJson($el);
        $this._updateFormElements();
  },

  _catchCheckboxUpdate: function (e) {
      var $this = e.data.context,
          $el = $(e.currentTarget);
      if($el.is('[data-form-make-default]')){
          var input = $el.data('accounting-input');
          if (input) {
              $('#' + input).prop('checked', $el[0].checked);
          }
          if($el[0].checked == true) {
              $el.val(1);
          } else {
              $el.val(0);
          }
      }
      $this._updateDataAllocationJson($el);
  },

  _catchUpdateEvent:function(e, data) {
    var $this = e.data.context;
    $this._updateFull(data);

  },

  _catchLoadEvent: function(e, data) {
	  var $this = e.data.context;


    $this._clearAllData();
    $this._loadData(data);

  },

  _catchClearEvent: function(e) {
    var $this = e.data.context;
    $this._clearAllData();
  },

  _catchRefreshEvent: function(e) {
     var $this = e.data.context;
    $this._processDataContainer();
    $this._setMode('view');

    $this._updateFormElements(true);

    if($this.accounts === 0) {
        $this._clearAllData();
    }
  },

  _catchFormFavoriteEvent: function(e) {
      var $btn = $(this);
      // need update only if we have button
      if ($btn.hasClass('btn')) {
          var $elName = $btn.parent().find('input[name="fav_name"]');
          if ($elName) {
              $elName.val('');
          }
      }
  },

  _updateSlideHeight: function(el) {
    var slideHeight = $(el).closest('.slide--current.slide').outerHeight(true);
    $('.deck.deck--horizontal').height(slideHeight);
  },

  _throwEventUpdateTab: function() {
	  var event = document.createEvent("HTMLEvents");
	  event.initEvent("updated", true, true);

	  if ($(this.options.tabAccounting).length > 0) {
      var target = $(this.options.tabAccounting)[0];
      target.dispatchEvent(event);
    }
  },

  _catchAccountingSelectUpdate: function(e, data) {
    if (e.currentTarget.dataset.requiredOn) {
      if (data && !$(e.currentTarget).hasClass('not-empty')) {
        $(e.currentTarget).addClass('not-empty');
      } else if (!data) {
        $(e.currentTarget).removeClass('not-empty');
      }
    }
    
    var $this = e.data.context;
    var accountingId = $('input.selectbox-data', e.currentTarget).data('accounting-input');
    var dependentFields = $('[data-required-on="'+accountingId+'"]', $this.$element);

    dependentFields.each(function(i, field) {
      var input = $('input.selectbox-data', field);
      var label = $('label', field);
      var hasData = !!data;
      // _catchEventRemove set data as empty object {}
      if (hasData && typeof data === 'object' && Object.keys(data).length === 0) {
          hasData = false;
      }

      var required = hasData;
      var classAction = hasData ? 'add' : 'remove';
      var requiredChanged = false;
      var revalidate = false;

      if ($(field).data('required-on-values')) {
        var values = $(field).data('required-on-values').toString().split(',');

        if (data && values.indexOf(data) != -1) {
          required = true;
          classAction = 'add';
        } else {
          required = false;
          classAction = 'remove';
        }
      }

      if (!required && input.attr('required') || !input.attr('required') && required) requiredChanged = true;

      if (requiredChanged && (input.closest('form').find('.has-feedback').length > 0 || input.closest('.has-feedback').length > 0)) revalidate = true;

      input.removeClass('parsley-error');
      $this._manageRequired(input, false, required);

      if (revalidate) {
        $this._revalidateDependentFields(input);
      }

      if (classAction === 'add') {
        label.addClass('required-on-active');
      } else {
        label.removeClass('required-on-active');
      }
    });

    var selectId = $(e.currentTarget).data('select-id');
    var filterFields = $('[data-parent-filter="'+selectId+'"]', $this.$element);
    var eventType = e.type;

    filterFields.each(function(i, field) {
      var input = $('input.selectbox-data', field);
      var formElement = input.closest('.account-form-element');
      var revalidate = false;
      if (input.closest('form').find('.has-feedback').length > 0 || input.closest('.has-feedback').length > 0) revalidate = true;

      if (data && Object.keys(data).length) {
          input.removeAttr('disabled');
          if (input.attr('data-disabled-parsley-required') === 'true') {
              $this._manageRequired(input, false, true);
          }
      } else {
          if (eventType === "select2-clearing") {
              input.attr('disabled', true);
              formElement.find('.select2-search-choice-close').trigger('mousedown');
          }
          if (input.attr('data-parsley-required') === 'true') {
              $this._manageRequired(input, true, false);
          }
      }

      if (revalidate) {
        $this._revalidateDependentFields(input);
      }
    });
  },

  _manageRequired: function(input, disabled, required) {
    input.attr('data-disabled-parsley-required', disabled);

    if (required) {
      input.attr('required', required);
      input.attr('data-parsley-required', required);
    } else {
      input.removeAttr('required');
      input.removeAttr('data-parsley-required');
    }
  },

  _revalidateDependentFields: function(input) {
    var form = input.closest('.account-form-element').parent();
    if (bq.global.parsley.validationEnabledForElement(form) || input.closest('[data-bq="validate-form"].bq-form').length <= 0) {
      $('.form-control-feedback', input.parent()).remove();
      input.parent().removeClass('has-error has-feedback has-success');

      bq.global.parsley.destroyElement(form);
      bq.global.parsley.setupElement(form);
      bq.global.parsley.validateElement(form);
    } else {
      $('.form-control-feedback', form).tooltip('destroy').remove();
      form.removeClass('has-error has-feedback has-success');

      bq.global.parsley.destroySingle(form);
      bq.global.parsley.setupSingle(form);
      bq.global.parsley.validate(form);
    }
  }
};

// ACCOUNTING PLUGIN DEFINITION
// =======================

var accountingManagementold = $.fn.accountingManagement;

$.fn.accountingManagement = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.accountingManagement');
    var options = $.extend({}, bq.accountingManagement.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.accountingManagement', (data = new bq.accountingManagement(this, options))); }
    data.init();
  });
};

$.fn.accountingManagement.Constructor = bq.accountingManagement;

// ACCOUNTING NO CONFLICT
// =================

$.fn.accountingManagement.noConflict = function () {
  $.fn.accountingManagement = accountingManagementold;
  return this;
};

$.fn.accountingValidate = function() {
    var options = $.extend({}, bq.accountingManagement.DEFAULTS);
    var element = this.context;
    if(!$(element).hasClass(options.entityContainerClass)){
        return true;
    }

    var hasError = $(element).find('.alert:visible, .alert-danger:visible').length;
    return !hasError;
};

// accounting DATA-API
// ==============

bq.accountingManagementInit = function() {
  $('[data-bq="accounting"]').each(function () {
    var $el = $(this);
    if($el.data('bq.accountingManagement')) { return; }
    $el.accountingManagement($el.data());
  });
};

bq.init.push(bq.accountingManagementInit);
